import Hero from './components/Hero';
import About from './components/About';
import Menu from './components/Menu';
import Director from './components/Director';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-gray-100 flex justify-center">
      <div className="w-full max-w-sm bg-white overflow-hidden">
        <Hero />
        <About />
        <Menu />
        <Director />
        <Contact />
        <Footer />
      </div>
    </div>
  );
}
